export default "__VITE_ASSET__2OSolbvO__"